<template>
  <backend-layout>
    <router-view></router-view>
  </backend-layout>
</template>

<script>
import BackendLayout from '@/components/layouts/BackendLayout'

export default {
  components: {
    BackendLayout
  },
  created () {
    this.$store.dispatch('backend/init')
  }
}
</script>

<style>
</style>
